<template>
  <td class="table-button-cell">
    <template v-if="visible">
      <ux-button
        :block="button.block"
        :color="button.color"
        :size="button.size"
        :loading="processing"
        :disabled="!enabled"
        @click.stop.prevent="clicked"
      >
        <template v-if="label">{{ label }}</template
        ><ux-icon v-if="button.icon" :icon="button.icon" right />
      </ux-button>
    </template>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  data() {
    return {
      processing: false,
    };
  },
  mixins: [TableCellMixin],
  computed: {
    visible() {
      return !this.hidden;
    },
    enabled() {
      const self = this;

      switch (typeof self.button.enabled) {
        case "function":
          return self.button.enabled(self.row, self.column);
          break;
        case "undefined":
        case "null":
          return true;
        default:
          return self.button.enabled;
      }
    },
    hidden() {
      const self = this;

      switch (typeof self.button.hidden) {
        case "function": {
          const evaluated = !!self.button.hidden(self.row, self.column);
          return evaluated;
        }
        case "undefined":
        case "null":
          return false;
        default:
          return !!self.button.hidden;
      }
    },
    button() {
      return this.column.button;
    },
    type() {
      return this.row?.meta?.type;
    },
    label() {
      const button = this.button;

      if (typeof button.text === "function") {
        return button.text(this);
      }

      return button.text;
    },
  },
  methods: {
    async clicked() {
      this.processing = true;
      try {
        await this.button.action(this.row, this.column, this);
      } finally {
        // Always clear the spinner — a rejected action otherwise leaves the
        // button stuck in its loading state
        this.processing = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
td {
  width: 60px;
  padding: 0.3em !important;

  .ux-btn {
    white-space: nowrap;
  }

  .ux-image {
    border-radius: 0.1em;
  }

  :deep(.ux-btn-text) {
    display: block;
    white-space: nowrap;
  }
}
</style>
